import { useHiveRenderingMetadata } from './use-hive-rendering-metadata.js';
import { useHiveTileBestFit } from './use-hive-tile-best-fit.js';
import { useHoneycombData } from './use-honeycomb-data.js';
import { useHoneycombShape } from './use-honeycomb-shape.js';
import { useHoneycombTooltipMetadata } from './use-honeycomb-tooltip-metadata.js';
import type { Overlay } from '../../core/components/overlay-tooltip/types.js';
import {
  useOverlayEventHandlers,
  type Options,
} from '../../core/hooks/useOverlayEventHandlers.js';
import { buildOverlayTooltipData } from '../utils/build-overlay-tooltip-data.js';
import { findClosestTileStrategy } from '../utils/find-closest-tile.js';

export const useOverlayEvents = (overlay: Overlay) => {
  const honeycombData = useHoneycombData();
  const { tilesCenters } = useHiveRenderingMetadata();
  const { tileWidth } = useHiveTileBestFit();
  const shape = useHoneycombShape();
  const { tooltipMetadata } = useHoneycombTooltipMetadata();

  const getTooltipDataFromEvent: Options['getTooltipData'] = (coords) => {
    const position = overlay.getAdjustedPositionsFromAbsolute(
      coords.clientX,
      coords.clientY,
    );
    const relativePosition = {
      x: position.relativeX ?? 0,
      y: position.relativeY ?? 0,
    };
    const closestTile = findClosestTileStrategy[shape](
      tileWidth,
      tilesCenters,
      relativePosition,
    );
    return closestTile !== undefined
      ? buildOverlayTooltipData(closestTile, honeycombData, tooltipMetadata)
      : undefined;
  };

  return useOverlayEventHandlers({
    getTooltipData: getTooltipDataFromEvent,
  });
};
